import { Fragment } from 'react';

const getDisplayName = (u) => {
  const name = `${u.firstName || ''} ${u.lastName || ''}`.trim();
  return name || u.email || 'User';
};

// % of live news that were modified before going live (total modified
// news with live status / total news made live).
const getEditedLivePercent = (u) => {
  if (!u.totalLive) return null;
  return Math.round((u.liveEditedCount / u.totalLive) * 100);
};

const getSortedLanguageCounts = (u) => {
  return Object.entries(u.liveLanguageCounts || {}).sort((a, b) => b[1] - a[1]);
};

const formatDate = (dateString) => {
  if (!dateString) return '—';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);
  return `${day}/${month}/${year}`;
};

const formatTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const hours24 = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours24 >= 12 ? 'PM' : 'AM';
  const hours12 = String(hours24 % 12 || 12).padStart(2, '0');
  return `${hours12}:${minutes} ${ampm}`;
};

// One publisher's stats row (+ an optional languages sub-row), rendered
// inside a <tbody> with the uns-table column layout: Email / Live-Total /
// Edits-before-live / Last Created.
const PublisherRow = ({ u }) => {
  const editedLivePercent = getEditedLivePercent(u);
  const langCounts = getSortedLanguageCounts(u);

  return (
    <Fragment>
      <tr className="uns-row">
        <td className="uns-email-cell">
          {u.profilePicture ? (
            <img
              src={u.profilePicture}
              alt=""
              className="uns-avatar"
              referrerPolicy="no-referrer"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextElementSibling.style.display = 'flex';
              }}
            />
          ) : null}
          <div
            className="uns-avatar-placeholder"
            style={{ display: u.profilePicture ? 'none' : 'flex' }}
          >
            {getDisplayName(u).charAt(0).toUpperCase()}
          </div>
          <div>
            <div className="uns-user-name">{getDisplayName(u)}</div>
            <div className="uns-user-email">{u.email}</div>
          </div>
        </td>
        <td>{u.totalLive}/{u.totalCreated}</td>
        <td>
          <div className="uns-ratio-line">{u.liveEditedCount}/{u.totalLive}</div>
          {editedLivePercent !== null ? (
            <span className={`uns-accuracy ${editedLivePercent <= 30 ? 'uns-accuracy-good' : editedLivePercent <= 60 ? 'uns-accuracy-mid' : 'uns-accuracy-low'}`}>
              {editedLivePercent}%
            </span>
          ) : (
            <span className="uns-accuracy uns-accuracy-na">NA</span>
          )}
        </td>
        <td className="uns-last-created-cell">
          <div className="uns-date-line">{formatDate(u.lastCreatedAt)}</div>
          {u.lastCreatedAt && <div className="uns-time-line">{formatTime(u.lastCreatedAt)}</div>}
        </td>
      </tr>
      {langCounts.length > 1 && (
        <tr className="uns-lang-row">
          <td colSpan={4}>
            <div className="uns-lang-strip">
              <span className="uns-lang-strip-label">Languages</span>
              {langCounts.map(([lang, count]) => (
                <span className="uns-lang-chip" key={lang}>{count}{lang}</span>
              ))}
            </div>
          </td>
        </tr>
      )}
    </Fragment>
  );
};

export default PublisherRow;
